<template>
  <div class="members">
    <el-row :gutter="24" class="stats-row">
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-user-solid" style="color: #c0c4cc;"></i> 总会员数</p>
          <div class="stat-value-wrap">
            <span class="stat-value">{{ formatNumber(stats.totalMembers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-circle-check" style="color: #E4393C;"></i> 有效会员数</p>
          <div class="stat-value-wrap">
            <span class="stat-value danger">{{ formatNumber(stats.validMembers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-star-off" style="color: #e6a23c;"></i> 业务经理数</p>
          <div class="stat-value-wrap">
            <span class="stat-value warning">{{ formatNumber(stats.managers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-user" style="color: #409EFF;"></i> 本月新增会员</p>
          <div class="stat-value-wrap">
            <span class="stat-value info">{{ formatNumber(stats.monthNew) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="member-card">
      <div class="search-bar">
        <el-input v-model="memberSearch" placeholder="搜索会员昵称/手机号/所属分身" prefix-icon="el-icon-search" size="small" style="width: 300px;" clearable />
        <el-select v-model="identityFilter" placeholder="会员身份（全部）" size="small" style="width: 160px;" clearable>
          <el-option label="普通粉丝" :value="0" />
          <el-option label="有效会员" :value="1" />
          <el-option label="业务经理" :value="2" />
        </el-select>
        <el-select v-model="branchFilter" placeholder="所属分身（全部）" size="small" style="width: 160px;" clearable>
          <el-option v-for="b in branchOptions" :key="b.id" :label="b.name" :value="b.id" />
        </el-select>
        <el-button type="danger" size="small" @click="handleSearch">搜索</el-button>
        <el-button size="small" @click="resetFilter">重置</el-button>
      </div>

      <el-table :data="memberList" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="id" label="会员ID" width="100" />
        <el-table-column label="头像" width="70">
          <template slot-scope="scope">
            <el-avatar :size="36" icon="el-icon-user-solid" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="昵称" width="120" />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column label="会员身份" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.identity_code === 2 ? 'warning' : scope.row.identity_code === 1 ? 'success' : 'info'" size="small">{{ scope.row.identity }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="branch" label="所属分身" width="140">
          <template slot-scope="scope">
            <span class="branch-name">{{ scope.row.branch }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计消费额" width="120">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.totalSpent }}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="180">
          <template slot-scope="scope">{{ scope.row.registerTime | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="最后活跃时间" width="180">
          <template slot-scope="scope">{{ scope.row.lastActive | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="openLogs(scope.row)">流水</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit" :current-page.sync="page" @current-change="fetchMembers" />
      </div>
    </el-card>

    <!-- 会员详情弹窗 -->
    <el-dialog :title="'会员详情 - ' + (detail.name || '')" :visible.sync="detailVisible" width="820px" top="6vh">
      <div v-loading="detailLoading" class="detail-body">
        <template v-if="detail && detail.member_id">
          <el-row :gutter="24" class="detail-profile">
            <el-col :span="4">
              <el-avatar :size="72" :src="detail.avatar" icon="el-icon-user-solid" />
            </el-col>
            <el-col :span="20">
              <div class="profile-name">
                {{ detail.name }}
                <el-tag :type="detail.identity_code === 2 ? 'warning' : detail.identity_code === 1 ? 'success' : 'info'" size="small">{{ detail.identity }}</el-tag>
              </div>
              <div class="profile-meta">
                <span>会员ID：{{ detail.id }}</span>
                <span>手机号：{{ detail.phone || '-' }}</span>
                <span>邀请码：{{ detail.invite_code || '-' }}</span>
              </div>
              <div class="profile-meta">
                <span>所属分身：{{ detail.branch }}</span>
                <span>上级：{{ detail.parent_nickname || '-' }}</span>
                <span>状态：
                  <el-tag :type="detail.status === 1 ? 'success' : 'danger'" size="small">{{ detail.status === 1 ? '正常' : '禁用' }}</el-tag>
                </span>
              </div>
            </el-col>
          </el-row>

          <el-divider content-position="left">账户资产</el-divider>
          <el-row :gutter="16" class="asset-grid">
            <el-col :span="6"><div class="asset-item"><p>余额</p><span>¥{{ detail.balance || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>冻结余额</p><span>¥{{ detail.freeze_balance || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>委托余额</p><span>¥{{ detail.delegated_balance || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>分红余额</p><span>¥{{ detail.dividend_balance || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>PV值</p><span>{{ detail.pv_point || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>金豆</p><span>{{ detail.gold_beans || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>冻结金豆</p><span>{{ detail.freeze_gold_beans || 0 }}</span></div></el-col>
            <el-col :span="6"><div class="asset-item"><p>连续签到</p><span>{{ detail.sign_continuous || 0 }}天</span></div></el-col>
          </el-row>

          <el-divider content-position="left">会员信息</el-divider>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="累计消费"><span class="price-bold">¥{{ detail.totalSpent || 0 }}</span></el-descriptions-item>
            <el-descriptions-item label="订单数">{{ detail.orderCount || 0 }} 单</el-descriptions-item>
            <el-descriptions-item label="会员有效期至">{{ detail.valid_expire_time || '-' }}</el-descriptions-item>
            <el-descriptions-item label="有效邀请数">{{ detail.invite_valid_count || 0 }}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{ detail.registerTime | formatDateTime }}</el-descriptions-item>
            <el-descriptions-item label="最后活跃时间">{{ detail.lastActive | formatDateTime }}</el-descriptions-item>
          </el-descriptions>
        </template>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 会员资金流水弹窗 -->
    <el-dialog :title="'会员资金流水 - ' + (logMember ? logMember.name : '')" :visible.sync="logVisible" width="860px">
      <el-table :data="logList" border stripe v-loading="logLoading" size="small">
        <el-table-column label="流水类型" width="150">
          <template slot-scope="scope">
            <el-tag size="small">{{ scope.row.log_type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="资金池" width="90">
          <template slot-scope="scope">{{ scope.row.fund_type_text }}</template>
        </el-table-column>
        <el-table-column label="变动金额" width="130">
          <template slot-scope="scope">
            <span :class="Number(scope.row.amount) >= 0 ? 'amount-in' : 'amount-out'">
              {{ Number(scope.row.amount) >= 0 ? '+' : '' }}{{ scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="变动前余额" width="120">
          <template slot-scope="scope">{{ scope.row.balance_before }}</template>
        </el-table-column>
        <el-table-column label="变动后余额" width="120">
          <template slot-scope="scope">{{ scope.row.balance_after }}</template>
        </el-table-column>
        <el-table-column prop="order_no" label="关联订单" width="150" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
        <el-table-column prop="create_time" label="时间" width="160" />
      </el-table>
      <div v-if="logTotal === 0" style="text-align:center;color:#909399;padding:20px;">该会员暂无资金流水记录</div>
      <div slot="footer">
        <el-pagination
          style="display:inline-block;"
          background
          layout="prev, pager, next"
          :total="logTotal"
          :page-size="20"
          :current-page.sync="logPage"
          @current-change="fetchLogs"
        />
        <el-button type="primary" @click="logVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMembers, getMemberDetail, getMemberLogs } from '@/api'

export default {
  name: 'Members',
  data() {
    return {
      memberSearch: '',
      identityFilter: '',
      branchFilter: '',
      memberList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      stats: { totalMembers: 0, validMembers: 0, managers: 0, monthNew: 0 },
      branchOptions: [],
      // 会员详情
      detailVisible: false,
      detailLoading: false,
      detail: {},
      // 资金流水
      logVisible: false,
      logLoading: false,
      logList: [],
      logTotal: 0,
      logPage: 1,
      logMember: null
    }
  },
  mounted() {
    this.fetchMembers()
  },
  methods: {
    formatNumber(num) {
      return num ? num.toLocaleString() : '0'
    },
    fetchMembers() {
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.memberSearch) params.keyword = this.memberSearch
      if (this.identityFilter !== '') params.member_type = this.identityFilter
      if (this.branchFilter) params.branch_id = this.branchFilter

      getMembers(params).then(res => {
        this.memberList = res.list || []
        this.total = res.total || 0
        if (res.stats) this.stats = res.stats
        if (res.branches) this.branchOptions = res.branches
      }).catch(() => {
        this.$message.error('获取会员列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.page = 1
      this.fetchMembers()
    },
    resetFilter() {
      this.memberSearch = ''
      this.identityFilter = ''
      this.branchFilter = ''
      this.page = 1
      this.fetchMembers()
    },
    handleDetail(row) {
      this.detail = {}
      this.detailVisible = true
      this.detailLoading = true
      getMemberDetail(row.id).then(res => {
        this.detail = res
      }).catch(() => {
        this.$message.error('获取会员详情失败')
      }).finally(() => {
        this.detailLoading = false
      })
    },
    // 会员资金流水
    openLogs(row) {
      this.logMember = row
      this.logList = []
      this.logTotal = 0
      this.logPage = 1
      this.logVisible = true
      this.fetchLogs()
    },
    fetchLogs() {
      if (!this.logMember) return
      this.logLoading = true
      getMemberLogs(this.logMember.id, { page: this.logPage, limit: 20 }).then(res => {
        this.logList = res.list || []
        this.logTotal = res.total || 0
      }).catch(() => {
        this.logList = []
        this.logTotal = 0
        this.$message.error('获取会员流水失败')
      }).finally(() => {
        this.logLoading = false
      })
    }
  }
}
</script>

<style scoped>
.stats-row { margin-bottom: 24px; }
.stat-card { border-radius: 8px; border: 1px solid #ebeef5; }
.stat-label { font-size: 12px; color: #909399; margin: 0 0 8px; display: flex; align-items: center; gap: 4px; }
.stat-value-wrap { display: flex; align-items: flex-end; gap: 4px; }
.stat-value { font-size: 28px; font-weight: bold; color: #303133; }
.stat-value.danger { color: #E4393C; }
.stat-value.warning { color: #e6a23c; }
.stat-value.info { color: #409EFF; }
.stat-unit { font-size: 12px; color: #c0c4cc; margin-bottom: 4px; }
.member-card { border-radius: 8px; }
.search-bar { display: flex; align-items: center; gap: 12px; padding: 0 0 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px; flex-wrap: wrap; }
.branch-name { color: #409EFF; }
.price-bold { font-weight: bold; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
.amount-in { color: #67c23a; font-weight: bold; }
.amount-out { color: #f56c6c; font-weight: bold; }
.detail-body { min-height: 200px; }
.detail-profile {
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.profile-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
}
.profile-meta {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.asset-grid { margin-top: 4px; }
.asset-item {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  text-align: center;
}
.asset-item p {
  margin: 0 0 6px;
  font-size: 12px;
  color: #909399;
}
.asset-item span {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.price-bold { color: #e6a23c; font-weight: bold; }
</style>
